<template>
  <chip-status
    :status="row.status"
  />
</template>

<script>
import ChipStatus from 'Support/components/chips/ChipStatus.vue';

export default {
  name: 'DataTableChipStatusRow',
  components: {
    ChipStatus,
  },
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
